export default {
  42161: "0x99D73e5d83148FA2b41248059061f91703Cf0516",
  43114: "0x072aD7f291AED59E7C4974EbdcF73B79DAC89051",
  8453: "0xcA11bde05977b3631167028862bE2a173976CA11",
  56: "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B",
  100: "0xAbd2FE441318a73414e3fa93297D3Bdb036CB2Fa",
  59144: "0xcA11bde05977b3631167028862bE2a173976CA11",
  5000: "0xcA11bde05977b3631167028862bE2a173976CA11",
  10: "0xcA11bde05977b3631167028862bE2a173976CA11",
  137: "0xed386Fe855C1EFf2f843B910923Dd8846E45C5A4",
  324: "0x1ADC6Ac76c6d35cED013cA0513919f7f53586fAf",
  169: "0xcA11bde05977b3631167028862bE2a173976CA11",
  1088: "0xc39aBB6c4451089dE48Cffb013c39d3110530e5C",
  534352: "0xcA11bde05977b3631167028862bE2a173976CA11",
  1101: "0xcA11bde05977b3631167028862bE2a173976CA11",
  81457: "0xcA11bde05977b3631167028862bE2a173976CA11",
  34443: "0xcA11bde05977b3631167028862bE2a173976CA11",
  80084: "0xcA11bde05977b3631167028862bE2a173976CA11",
  80094: "0xcA11bde05977b3631167028862bE2a173976CA11"
} as { [key: number]: string };
